let counter = 0;

export function nextId(prefix?: string): string {
  counter += 1;
  return `${prefix || "ui-field"}-${counter}`;
}

export function __resetForTests(): void {
  counter = 0;
}
